import { withAnalyticsHandler } from 'hoc/with-analytics-handler'

export const TrackedButton = withAnalyticsHandler('button', ['Click'])
